export default "__VITE_ASSET__BdjFr01c__"